import AppLink from "@/integrations/next/components/AppLink"
import IconButton from "@/ui/atoms/IconButton"
import Typography from "@/ui/atoms/Typography"
import Drawer from "@/ui/dialogs/Drawer"
import { Close } from "@/ui/icons"
import { ReactNode } from "react"
import { useLocale } from "@/modules/navigation"

export interface MenuItem {
  item: ReactNode
}

export interface BottomContents {
  email?: string
}

export interface MenuProps {
  className?: string
  open: boolean
  onClose: () => void
  logo?: ReactNode
  menuItems?: MenuItem[]
  bottomContents?: BottomContents
}

const Menu = ({
  className,
  open,
  onClose,
  logo,
  menuItems,
  bottomContents,
}: MenuProps) => {
  const { changeLocale, locale } = useLocale()

  const handleLocaleChange = (newLocale: string) => {
    changeLocale(newLocale)
    onClose()
  }

  return (
    <Drawer
      open={open}
      onClose={onClose}
      position="right"
      maxWidth={460}
      className={className}
    >
      <div className="py-6 h-full flex flex-col items-center justify-between xl:items-end xl:pr-[80px] xl:py-8">
        <div className="px-6 xl:pr-0 xl:pl-16 w-full flex justify-between">
          <div>
            <AppLink href="/">{logo}</AppLink>
          </div>
          <IconButton onClick={onClose}>
            <Close height={24} width={24} />
          </IconButton>
        </div>
        <div className="text-center xl:text-right">
          {menuItems?.map((x, i) => (
            <div key={i} className="my-8">
              {x.item}
            </div>
          ))}
        </div>

        <div>
          <div className="flex justify-end mb-4">
            <a
              onClick={() => handleLocaleChange("it")}
              className={locale === "it" ? "font-bold" : ""}
            >
              IT
            </a>
            <div className="mx-2">•</div>
            <a
              onClick={() => handleLocaleChange("en")}
              className={locale === "en" ? "font-bold" : ""}
            >
              EN
            </a>
            <div className="mx-2">•</div>
            <a
              onClick={() => handleLocaleChange("fr")}
              className={locale === "fr" ? "font-bold" : ""}
            >
              FR
            </a>
          </div>
          {bottomContents?.email && (
            <Typography
              variant={"body1"}
              className="mb-2"
              weight={"medium"}
              underline
            >
              <a href={`mailto:${bottomContents.email}`}>
                {bottomContents.email}
              </a>
            </Typography>
          )}
        </div>
      </div>
    </Drawer>
  )
}

export default Menu
